class StickyBuyButton extends HTMLElement {
  constructor() {
    super();

    this.activeClass = "wt-product__sticky-buy--show";
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    // MyAlma CRO: el botón fijo no se usa dentro de la compra rápida.
    if (this.closest(".wt__quick-buy")) {
      this.remove();
      return;
    }

    const addToCartModule = document.querySelector(".wt-product__add-to-cart");
    const btn = this.querySelector("button");
    if (!addToCartModule || !btn) {
      this.remove();
      return;
    }

    // MyAlma CRO: el botón fijo lleva al formulario de compra (no añade), así que dice "Comprar".
    const label = btn.querySelector("span");
    if (label) label.textContent = "Comprar";
    btn.setAttribute("aria-label", "Comprar: ir a las opciones de compra");

    // MyAlma CRO: se quita el título de los elementos observados para que el botón
    // se vea desde la carga mientras el formulario de compra no esté en pantalla.
    const forObserver = document.querySelectorAll(
      ".wt-product__add-to-cart, .wt-footer",
    );

    let intersected = [];

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      addToCartModule.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        isIntersecting
          ? intersected.push(target)
          : (intersected = intersected.filter((item) => item !== target));
      });

      if (intersected.length) {
        this.classList.remove(this.activeClass);
      } else {
        this.classList.add(this.activeClass);
      }
    });

    forObserver.forEach((item) => {
      observer.observe(item);
    });
  }
}

customElements.define("sticky-buy-button", StickyBuyButton);

if (!customElements.get("gallery-fashion")) {
  customElements.define(
    "gallery-fashion",
    class GalleryFashion extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("section");
        this.logoBanner = this;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.removeEventsWhenDesignMode();
      }

      addEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.addEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.addEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      removeEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.removeEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.removeEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      reinitAfterDelay() {
        setTimeout(() => this.reinit(), 0);
      }

      isFirstSection() {
        const sectionWrapper = document.querySelector("#root");
        const firstSection = sectionWrapper.querySelector("section");
        this.section = this.closest("section");
        const currentSection = this.section;

        return firstSection === currentSection;
      }

      handleResize() {
        this.setTopMargin();
        this.positioningProductInfo();
      }

      observeHeader() {
        const header = document.querySelector(".wt-header");
        const activeTransparentClass = "wt-header--fashion-transparent";

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 },
        );

        observer.observe(this.querySelector(".wt-product__gallery"));
      }

      calculateOffset() {
        const header = document.querySelector("header");
        const headerHeight = header.offsetHeight;
        const offset =
          this.isTransparentHeaderEnabled() && this.isFirstSection()
            ? headerHeight
            : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        if (offset) {
          this.section.style.marginTop = `-${offset}px`;
        } else {
          this.section.style.marginTop = 0;
        }
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector(".wt-header");
        return (
          header.dataset.transparent &&
          header.classList.contains("wt-header--v3")
        );
      }

      renderProgressBar() {
        const thumbsGallery = this.querySelector("[data-thumbs]");
        const progressBarElement = document.createElement("div");
        progressBarElement.classList.add("gallery-fashion__progress-bar");
        const progressBarIndicatorElement = document.createElement("div");
        progressBarIndicatorElement.classList.add(
          "gallery-fashion__progress-bar-indicator",
        );
        progressBarElement.appendChild(progressBarIndicatorElement);
        thumbsGallery.appendChild(progressBarElement);

        function updateProgressBar() {
          const images = this.querySelector("gallery-section");
          const progressBar = progressBarIndicatorElement;

          const scrolled = window.scrollY;
          const maxHeight = images.clientHeight - window.innerHeight;
          const scrollPercentage = (scrolled / maxHeight) * 100;

          const progressBarHeight = progressBarElement.clientHeight;
          const progressHeight = progressBar.clientHeight;
          const maxProgressTop = progressBarHeight - progressHeight;
          const progressTop = Math.min(
            (scrollPercentage / 100) * maxProgressTop,
            maxProgressTop,
          );

          progressBar.style.top = `${progressTop}px`;

          if (progressTop === maxProgressTop) {
            thumbsGallery.classList.add("finished");
          } else {
            thumbsGallery.classList.remove("finished");
          }
        }

        window.addEventListener("scroll", updateProgressBar.bind(this));

        function handleThumbsClick(event) {
          if (event.target.className === "wt-product__img") {
            const thumbnails = Array.from(
              event.currentTarget.querySelectorAll("img"),
            );
            const index = thumbnails.indexOf(event.target);

            const fullImage = this.querySelectorAll(
              ".wt-masonry__wrapper .wt-product__img, .wt-masonry__wrapper .wt-product__thumbnail-video",
            )[index];

            fullImage.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        thumbsGallery.addEventListener("click", handleThumbsClick.bind(this));
      }

      positioningProductInfo() {
        const productInfo = this.querySelector(".wt-product__main");
        const mediaDesktop = window.matchMedia("(min-width: 1200px)");

        if (mediaDesktop.matches) {
          productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
        }

        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (mediaDesktop.matches) {
              productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
            }
          }
        });

        const observedElement = productInfo;
        resizeObserver.observe(observedElement);
      }

      attachEvents() {
        window.addEventListener("resize", this.handleResize.bind(this));
      }

      init() {
        this.reinitAfterDelay = this.reinitAfterDelay.bind(this);
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
          this.attachEvents();
        }

        this.renderProgressBar();
        this.positioningProductInfo();
        this.addEventsWhenDesignMode();
      }

      reinit() {
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
        }
        this.positioningProductInfo();
      }
    },
  );
}

/* MyAlma CRO (2026-10): si la variante elegida está agotada y Klaviyo ofrece el aviso de stock,
   "Avísame cuando esté disponible" ocupa el lugar del botón "Agotado".
   Klaviyo inserta su botón en el primer formulario /cart/add de la ficha (junto al precio):
   se mueve debajo del formulario de compra. Si hay dos avisos visibles, se deja uno.
   "Agotado" solo se oculta cuando el aviso de Klaviyo está cargado (#klaviyo-bis-iframe);
   si Klaviyo no carga (p. ej. un bloqueador), se mantiene "Agotado" como hasta ahora. */
(function () {
  function syncBackInStock() {
    document.querySelectorAll(".main-product__buy-buttons--container").forEach(function (box) {
      if (box.closest(".wt__quick-buy")) return;
      var form = box.querySelector("product-form.wt-product__add-to-cart");
      var submit = box.querySelector('button[name="add"]');
      if (!form || !submit) return;
      var section = box.closest(".shopify-section") || document;

      section.querySelectorAll(".klaviyo-bis-trigger").forEach(function (trigger) {
        if (!box.contains(trigger) && !trigger.closest(".wt__quick-buy")) {
          form.insertAdjacentElement("afterend", trigger);
        }
      });

      var visible = null;
      box.querySelectorAll(".klaviyo-bis-trigger").forEach(function (trigger) {
        var shownByKlaviyo = trigger.style.display !== "none";
        if (shownByKlaviyo && !visible) {
          visible = trigger;
          trigger.classList.remove("ma-bis-dup");
        } else if (shownByKlaviyo) {
          trigger.classList.add("ma-bis-dup");
        } else {
          trigger.classList.remove("ma-bis-dup");
        }
      });

      var klaviyoReady = Boolean(document.getElementById("klaviyo-bis-iframe"));
      box.classList.toggle("ma-bis-on", Boolean(visible) && submit.disabled && klaviyoReady);
    });
  }

  var pending = null;
  function scheduleSync() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      syncBackInStock();
    }, 60);
  }

  function startBackInStock() {
    syncBackInStock();
    document.querySelectorAll(".product-section").forEach(function (root) {
      new MutationObserver(scheduleSync).observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["disabled", "style"],
      });
    });
    // Klaviyo añade su iframe del aviso al <body> cuando termina de cargar.
    if (document.body) {
      new MutationObserver(scheduleSync).observe(document.body, { childList: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startBackInStock);
  } else {
    startBackInStock();
  }
})();
